// Skeleton loading placeholder
import { cn } from '../../lib/utils'

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string | number
  height?: string | number
  rounded?: boolean
}

export function Skeleton({ className, width, height, rounded, style, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse bg-[var(--fc-gray-200)] dark:bg-[var(--fc-gray-700)]',
        rounded ? 'rounded-full' : 'rounded',
        className
      )}
      style={{ width, height, ...style }}
      aria-hidden="true"
      {...props}
    />
  )
}

// Preset card skeleton
export function CardSkeleton() {
  return (
    <div className="rounded-lg border border-[var(--fc-border)] bg-[var(--fc-surface)] p-4 space-y-3">
      <div className="flex items-center gap-3">
        <Skeleton width={40} height={40} rounded />
        <div className="flex-1 space-y-2">
          <Skeleton height={14} className="w-3/4" />
          <Skeleton height={12} className="w-1/2" />
        </div>
      </div>
      <Skeleton height={12} className="w-full" />
      <Skeleton height={12} className="w-5/6" />
    </div>
  )
}

// Preset row skeleton per tabelle
export function RowSkeleton({ cols = 4 }: { cols?: number }) {
  return (
    <div className="flex items-center gap-4 px-4 py-3">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} height={14} className={`flex-1 ${i === 0 ? 'max-w-[120px]' : ''}`} />
      ))}
    </div>
  )
}
